import styled from 'styled-components';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import Link from '../../Link';

export const BottomNavBarWrapper = styled.div`
  min-height: ${spacing(1)};
  background: ${colors.core03};
  // stretch to full width
  margin: 0 calc(50% - 50vw);
  // restore width of content
  padding: 0 calc(50vw - 50%);

  padding-bottom: ${spacing(2)};
  margin-top: 0;

  display: flex;
  align-items: flex-start;
  flex-direction: column;

  ${mediaQuery.desktop`
    margin-top: auto;
    margin-bottom: auto;
    padding-bottom: 0;
    align-items: left;
    flex-direction: row;
  `}
`;

export const BottomNavBarItem = styled.div`
  & > a {
    ${fonts.paragraphSmall}
    color: white;
    text-decoration: none;
  }
  display: flex;
  height: ${spacing(7)};

  ${mediaQuery.desktop`
    margin: 0 20px;
    align-self: center;
    &:first-child {
      margin-left: 0;
    }
  `}
`;

export const BottomNavBarLink = styled(Link)`
  align-self: center;
  ${fonts.paragraphSmall}
  :hover, :focus-visible {
    color: ${colors.neutral08};
  }
`;

export const BottomBorder = styled.div`
  display: block;
  height: ${spacing(1)};
  color: ${colors.core01};
  // stretch to full width
  margin: 0 calc(50% - 50vw);
`;
